
import React, { useState,useEffect } from "react";
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Footer from './Components/Footer/Footer';
import Home from './Components/Home/Home';
import Navbar from './Components/Navbar/Navbar';
import Aboutus from './Components/Aboutus/Aboutus';
import Servicesmain from './Components/Servicesmain/Servicesmain';
import Contact from './Components/Contact/Contact';
import { useLocation } from "react-router-dom";
import Header from './Components/Header/Header';
import CategorySection from './Components/Category/CategorySection';
import ProductPage from "./Components/Category/Productpage";


function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'  
    });
  }, [pathname]);

  return null;
}
function App() {
  const [cart, setCart] = useState([]);
  return (
    <Router>
      <Header cartCount={cart.length}/>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/categorysection" element={<CategorySection />} />
        <Route path="/products/:category" element={<ProductPage/>} />
        <Route path="/aboutus" element={<Aboutus />} />
        <Route path="/servicesmain" element={<Servicesmain />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
